enum TableEvents {
  EDIT_FIELD = 'edit-field',
  COMMIT_FIELD_EDITING = 'commit-field-editing',
  CANCEL_FIELD_EDITING = 'cancel-field-editing',
  LOADING_SELECTION = 'loading-selection',
  SELECTION_CHANGED = 'selection-changed',
}

export default TableEvents;
